import request from 'utils/request';

export default async function deleteZip(id: any): Promise<any> {
  try {
    await request(`/lineDriveService/mfgRepDetails/${id}`, {
      method: 'DELETE'
    });
  } catch (error) {
    let errorMessage = 'Failed to do something exceptional';
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    console.log(errorMessage);
  }
}
